import { Tracker } from 'usage-tracker-core';
import { LockedTrackerInstance } from 'usage-tracker-core/trackerTypes';
import events from '../../events.yaml';

export const cloneTracker = (
  trackerInstance: Tracker | LockedTrackerInstance<{ standalone: true }>,
  usageTrackerLocation?: string
): Tracker => {
  return (trackerInstance as Tracker).clone({
    events,
    standalone: false,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation,
    },
  });
};

export const cloneStandaloneTracker = (
  trackerInstance: Tracker | LockedTrackerInstance<{ standalone: true }>,
  usageTrackerLocation?: string
): LockedTrackerInstance<{ standalone: true }> => {
  return (trackerInstance as Tracker).clone({
    standalone: true,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation,
    },
  });
};
